/**
 * NỘI DUNG TRANG SKILL VIDEO DƯỢC SĨ / CHUYÊN GIA CHIA SẺ (/tools/video-chuyen-gia-chia-se)
 * và TRANG HƯỚNG DẪN (/tools/video-chuyen-gia-chia-se/huong-dan — SkillGuidePage, đọc trường `guide`).
 *
 * Dùng chung trang VideoBatchToolPage — cấu trúc trường giống storyVideoSkillContent.js, thêm:
 * - guidePath: bấm tải plugin thì mở trang hướng dẫn ở tab mới.
 * - guideDownloadLabel: nhãn nút tải file hướng dẫn Word (getGuideDownload ở AppRoutes).
 *
 * File trên máy chủ (DESKTOP_TOOLS ở pharmacy-tool.controller.js):
 * - web/back-end/storage/tools/skill_chuyen_gia_chia_se.zip ('expert-video-skill') — plugin ChatGPT, khách tải nguyên file lên.
 * - web/back-end/storage/tools/Huong_dan_cai_dat_va_su_dung_NT_VIDEO_FLOW.docx ('expert-video-guide').
 * Ảnh trong trang hướng dẫn lấy từ file Word (public/images/tools/guides/video-chuyen-gia-buoc-*.png).
 * Tải cần mua gói TOOL_VIDEO_CHUYEN_GIA (50.000đ / 12 tháng). Nội dung đối chiếu file Word và SKILL.md bản 0.12.0 (22/10/2026)
 * — đổi bản plugin hoặc file Word thì sửa lại cả `installSteps` lẫn `guide`.
 */
export const EXPERT_VIDEO_SKILL_TOOL = {
  published: true,

  slug: 'video-chuyen-gia-chia-se',
  contentFile: 'expertVideoSkillContent.js',
  name: 'Skill Video Chuyên Gia Chia Sẻ',
  kindLabel: 'PLUGIN CHATGPT + GOOGLE FLOW',
  tagline: 'Gõ chủ đề và thời lượng, ChatGPT đưa 2 lời thoại cho dược sĩ dẫn, chọn 1 là có prompt từng cảnh để Google Flow dựng video dọc',
  intro:
    'Cài plugin vào ChatGPT một lần. Mỗi video: gõ chủ đề và tổng thời lượng (ví dụ "Thói quen ăn uống hại gan, 40 giây"). ' +
    'Plugin đưa 2 phương án lời thoại có câu mở đầu giữ chân người xem; bạn chọn 1 hoặc 2 là có lời thoại và prompt cho từng cảnh 10 giây. ' +
    'Bạn tạo từng cảnh trên Google Flow với cùng một ảnh người dẫn, rồi ghép lại thành video khung dọc 9:16.',
  version: '0.12',
  fileSize: '',
  updatedAt: '22/10/2026',
  platforms: ['Máy tính có trình duyệt', 'ChatGPT', 'Google Flow'],
  image: '/images/tools/skill-video-chuyen-gia-banner.jpg',
  heroBanner: '/images/tools/skill-video-chuyen-gia-banner.jpg',

  downloadLabel: 'Tải plugin (.zip)',
  loginLabel: 'Đăng nhập để mua / tải plugin',
  guidePath: '/tools/video-chuyen-gia-chia-se/huong-dan',
  guideDownloadLabel: 'Tải hướng dẫn (Word)',

  // YouTube Shorts (chỉ điền ID): youtube.com/shorts/R0YWuWx5EP8
  sampleVideos: [{ youtubeId: 'R0YWuWx5EP8', title: 'Video mẫu' }],
  sampleVideosNote: 'Video dược sĩ chia sẻ làm ra từ plugin, các cảnh 10 giây ghép lại.',

  highlights: [
    { value: '2 concept', label: 'lời thoại hoàn chỉnh cho mỗi chủ đề, chọn 1 là xong' },
    { value: '10 giây', label: 'mỗi cảnh; video 40 giây có 4 cảnh, 30 giây có 3 cảnh' },
    { value: '1 ảnh', label: 'người dẫn dùng cho mọi cảnh, giữ đúng khuôn mặt, trang phục' },
  ],

  features: [
    { title: 'Lời thoại giữ chân người xem', desc: 'Mỗi chủ đề đưa 2 phương án lời thoại có câu mở đầu gây chú ý, nhịp nói tự nhiên như dược sĩ đang chia sẻ, không đọc như MC.' },
    { title: 'Tự chia cảnh, viết prompt', desc: 'Chọn 1 phương án là có lời thoại từng cảnh và prompt cho Google Flow, có đổi góc quay và cảnh minh họa.' },
    { title: 'Giữ đúng người dẫn', desc: 'Prompt khóa khuôn mặt, tóc, trang phục theo ảnh tham chiếu để các cảnh khớp nhau khi ghép.' },
    { title: 'Sửa nhanh từng cảnh', desc: 'Sửa lời thoại hoặc riêng một cảnh bằng một câu lệnh, không phải làm lại từ đầu.' },
  ],

  audience: [
    'Dược sĩ, chủ nhà thuốc muốn làm video chia sẻ kiến thức sức khỏe',
    'Nhân viên marketing nhà thuốc cần ra video người dẫn đều đặn mà không cần quay',
  ],

  requirements: [
    { label: 'ChatGPT', value: 'Tài khoản ChatGPT có mục Plugins hoặc Skills; nên dùng ChatGPT trên máy tính' },
    { label: 'Google Flow', value: 'Tài khoản Google Flow có quyền và lượt tạo video' },
    { label: 'Ảnh người dẫn', value: 'Một ảnh rõ mặt, dùng chung cho mọi cảnh (chỉ cần khi tạo video trên Flow)' },
    { label: 'Công cụ dựng', value: 'CapCut hoặc công cụ bạn quen dùng để ghép các cảnh' },
  ],

  installTitle: 'Hướng dẫn dùng plugin',
  installSubtitle: 'Tóm tắt từ trang hướng dẫn đầy đủ (mở tự động khi bấm tải). Cài plugin chỉ làm một lần.',
  installTabLabel: 'Các bước',

  installSteps: [
    {
      title: 'Tải plugin',
      desc: 'Bấm "Tải plugin (.zip)". Trang hướng dẫn có ảnh từng bước sẽ mở ở tab mới.',
      tip: 'Giữ nguyên file .zip, không giải nén — ChatGPT nhận nguyên file.',
    },
    {
      title: 'Cài plugin vào ChatGPT (một lần)',
      desc: 'Trong ChatGPT: bấm Plugins ở thanh bên trái → Add → Upload plugin archive → kéo thả hoặc chọn file skill_chuyen_gia_chia_se.zip → Add plugin.',
    },
    {
      title: 'Kiểm tra đã cài',
      desc: 'Mở cuộc trò chuyện mới, gõ @ và chọn "NT Trợ lý VIDEO FLOW". Plugin hiện trong danh sách và chọn dùng được là xong.',
      tip: 'Chỉ đính kèm file vào khung chat thì chưa phải là cài đặt.',
    },
    {
      title: 'Gõ chủ đề, chọn lời thoại',
      desc: 'Gõ chủ đề và tổng thời lượng, có thể thêm bối cảnh, người xem, giọng điệu. Ví dụ: "Thói quen ăn uống hại gan có thể bạn chưa biết, 40 giây, HOST đứng tại quầy thuốc". Đọc 2 phương án, trả lời "1" hoặc "2".',
    },
    {
      title: 'Tạo từng cảnh trên Google Flow',
      desc: 'Mở Flow, chọn khung dọc 9:16. Thêm cùng một ảnh người dẫn làm tham chiếu, dán toàn bộ prompt của cảnh 1, tạo và kiểm tra clip; làm tiếp các cảnh còn lại.',
      tip: 'Chép đủ cả khối prompt mỗi cảnh để giữ lời thoại và quy tắc giữ đúng nhân vật.',
    },
    {
      title: 'Ghép video',
      desc: 'Ghép các clip theo thứ tự bằng CapCut hoặc công cụ dựng quen dùng, cắt phần thừa và kiểm tra tổng thời lượng.',
      tip: 'Xem lại thông tin sức khỏe trong video trước khi đăng.',
    },
  ],

  installStepsMac: [],

  youtubeVideoId: '',

  faqs: [
    {
      q: 'Plugin giá bao nhiêu?',
      a: '50.000đ, dùng 12 tháng, tải plugin và file hướng dẫn về nhiều lần. Thanh toán bằng QR chuyển khoản, mở tải ngay sau khi chuyển khoản thành công. Phí dùng ChatGPT và lượt tạo video Google Flow tính riêng theo tài khoản của bạn.',
    },
    {
      q: 'Có cần giải nén file .zip không?',
      a: 'Không. Tải nguyên file skill_chuyen_gia_chia_se.zip lên ChatGPT (Plugins → Add → Upload plugin archive).',
    },
    {
      q: 'Không thấy mục Plugins trong ChatGPT?',
      a: 'Tên mục có thể khác theo tài khoản hoặc phiên bản. Dùng ChatGPT trên máy tính; nếu tài khoản có Skill Creator, gõ @ chọn Skill Creator, đính kèm file và nhờ tạo skill cá nhân tên "NT Trợ lý VIDEO FLOW" (câu lệnh có trong trang hướng dẫn).',
    },
    {
      q: 'Chữ tiếng Việt trên hình bị sai?',
      a: 'Nhắn: "Viết lại prompt cảnh 2 không có chữ trên hình", rồi thêm chữ đúng bằng công cụ dựng.',
    },
    {
      q: 'Flow không có đúng thời lượng?',
      a: 'Prompt không đổi được giới hạn của Flow. Cắt, chỉnh thời lượng lúc ghép video.',
    },
    {
      q: 'Plugin có tự tạo video không?',
      a: 'Không. Plugin viết lời thoại và prompt; video tạo trên Google Flow bằng tài khoản và lượt của bạn.',
    },
  ],

  support: {
    text: 'Cài plugin hoặc làm video gặp khó khăn? Gọi hoặc nhắn Zalo đội hỗ trợ kèm ảnh chụp màn hình.',
    phone: '0812539539',
    phoneLabel: '0812.539.539',
  },

  ctaTitle: 'Sẵn sàng làm video dược sĩ chia sẻ?',
  ctaText: 'Tải plugin, cài vào ChatGPT trong vài phút và gõ chủ đề đầu tiên.',

  // Trang hướng dẫn đầy đủ (SkillGuidePage) — chép từ file Word Huong_dan_cai_dat_va_su_dung_NT_VIDEO_FLOW.docx
  guide: {
    title: 'Hướng dẫn cài đặt và sử dụng skill',
    subtitle: 'NT Trợ lý VIDEO FLOW dành cho dược sĩ và chuyên gia',
    intro:
      'Skill giúp sản xuất nội dung, sau đó chia cảnh và tạo prompt cho Google Flow Veo3. Bạn tạo video trong Flow rồi ghép các clip theo thứ tự.',
    flow: ['Nhập chủ đề', 'Chọn concept', 'Lấy prompt', 'Tạo clip trong Flow'],
    sections: [
      {
        title: 'Chuẩn bị trước khi bắt đầu',
        paragraphs: [
          'Bạn cần tài khoản ChatGPT có tính năng Skills hoặc Plugins, file skill vừa tải về và tài khoản Google Flow có quyền tạo video. Để dùng file skill, ưu tiên ChatGPT trên máy tính.',
        ],
        note: 'Tên mục và quyền sử dụng có thể khác theo tài khoản hoặc phiên bản. Skill tạo kịch bản và prompt; không tự cấp quyền hoặc lượt tạo video trên Flow.',
      },
      {
        title: 'Cài skill từ tệp tải về',
        steps: [
          {
            title: 'Lưu tệp skill',
            text: 'Tải file skill_chuyen_gia_chia_se.zip về máy. Giữ nguyên gói .zip, không giải nén.',
          },
          {
            title: 'Cách 1 — Tải plugin lên ChatGPT (4 bước như hình)',
            text: 'Bấm Plugins ở thanh bên trái (1) → nút Add (2) → Upload plugin archive (3) → kéo thả file hoặc bấm "click to upload" (4), rồi bấm Add plugin.',
            images: [
              { src: '/images/tools/guides/video-chuyen-gia-buoc-1.png', alt: 'Bước 1–3: Plugins → Add → Upload plugin archive' },
              { src: '/images/tools/guides/video-chuyen-gia-buoc-2.png', alt: 'Bước 4: tải file plugin lên' },
            ],
          },
          {
            title: 'Cách 2 — Dùng Skill Creator',
            text: 'Nếu tài khoản có Skill Creator: trong ChatGPT gõ @ và chọn Skill Creator, đính kèm file skill và gửi câu lệnh:',
            quote:
              'Hãy tạo skill cá nhân từ tệp đính kèm, tên hiển thị NT Trợ lý VIDEO FLOW. Giữ nguyên toàn bộ workflow và quy tắc, không rút gọn hay viết lại. Nếu cần bước cài đặt bổ sung, hãy hướng dẫn tôi thực hiện.',
          },
          {
            title: 'Kiểm tra đã cài',
            text: 'Làm theo hướng dẫn hiện ra. Mở cuộc trò chuyện mới, gõ @ và chọn skill vừa cài. Chỉ xem là đã cài khi skill xuất hiện trong danh sách và chọn dùng được. Đính kèm file vào chat đơn thuần chưa phải là cài đặt.',
          },
        ],
      },
      {
        title: 'Nhập yêu cầu và chọn nội dung',
        paragraphs: [
          'Sau khi chọn skill bằng @, nhập chủ đề và tổng thời lượng video. Có thể thêm bối cảnh, đối tượng người xem và giọng điệu mong muốn. HOST là người dẫn xuất hiện trong video. Ví dụ:',
        ],
        quote:
          'Chủ đề: Thói quen ăn uống hại gan có thể bạn chưa biết\n40 giây\nBối cảnh: HOST đứng tại quầy thuốc\nGiọng điệu: Gần gũi, dễ hiểu, chuyên nghiệp',
        after:
          'Skill trả về đúng 2 concept, tức 2 phương án lời thoại hoàn chỉnh. Đọc, yêu cầu sửa nếu cần, rồi trả lời "1" hoặc "2" để chọn. Chưa cần gửi ảnh HOST ở bước này.',
      },
      {
        title: 'Nhận cảnh và prompt',
        paragraphs: [
          'Sau khi bạn chọn, skill tự xuất toàn bộ lời thoại từng cảnh và prompt tiếng Anh có lời thoại tiếng Việt. Video 40 giây thường gồm 4 cảnh × 10 giây; 30 giây gồm 3 cảnh × 10 giây.',
          'Mỗi cảnh có thay đổi góc quay, cảnh minh họa và giọng HOST ngoài hình. Sao chép toàn bộ khối prompt của từng cảnh để giữ đủ lời thoại, nhịp dựng và quy tắc đồng nhất nhân vật.',
        ],
      },
      {
        title: 'Tạo video trong Google Flow',
        list: [
          'Mở Flow, chọn công cụ hoặc chế độ tạo video phù hợp với tài khoản. Thiết lập khung dọc 9:16 và thời lượng theo từng prompt nếu công cụ hỗ trợ.',
          'Thêm cùng một ảnh HOST làm tham chiếu nhân vật cho các clip, nếu chế độ đang dùng hỗ trợ. Ảnh dùng để giữ khuôn mặt, tóc và trang phục. Không ép ảnh làm khung hình đầu nếu muốn cảnh mở đầu mới.',
          'Dán prompt cảnh 1, tạo và kiểm tra clip. Tiếp tục các cảnh còn lại với cùng ảnh tham chiếu. Kiểm tra lời nói, khẩu hình, nhân vật và chữ tiếng Việt trước khi tải.',
          'Ghép các clip theo thứ tự bằng công cụ dựng bạn quen dùng, chẳng hạn CapCut. Cắt phần thừa và kiểm tra tổng thời lượng. Nếu Flow không có đúng thời lượng yêu cầu, điều chỉnh lúc dựng; prompt không thay đổi được giới hạn của công cụ.',
        ],
      },
      {
        title: 'Câu lệnh sửa nhanh',
        commands: [
          { label: 'Sửa nội dung', text: 'Sửa concept 1 cho dễ hiểu hơn, giữ tổng thời lượng 40 giây. Chưa tạo prompt.' },
          { label: 'Sửa một cảnh', text: 'Sửa cảnh 2, giữ nguyên lời thoại, thêm cảnh minh họa lớn. Xuất lại toàn bộ prompt riêng cảnh 2.' },
          { label: 'Chữ tiếng Việt bị sai', text: 'Viết lại prompt cảnh 2 không có chữ trên hình.', after: 'Sau đó thêm chữ đúng bằng công cụ dựng.' },
        ],
        note: 'Trước khi đăng: rà soát thông tin sức khỏe và mọi nội dung đã sửa. Prompt giúp định hướng; vẫn cần kiểm tra video thực tế.',
      },
    ],
  },
};
